import React, {useEffect, useState} from "react";
import axios from "axios";
import {baseUrl} from "../Univ.js";
import "./IoTStyles.css";
function IoTLiveMonitoring() {
    const [ward, setWard] = useState("ICU");
    const [observations, setObservations] =
        useState([]);
    const [loading, setLoading] =
        useState(false);
    const loadMonitoring = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl +
                "iot-ward-monitoring/" +
                encodeURIComponent(ward) +
                "/"
            );
            setObservations(
                response.data
            );
        } catch (error) {
            console.log(
                "IoT Monitoring Error:",
                error
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadMonitoring();
        const interval =
            setInterval(
                loadMonitoring,
                2000
            );
        return () =>
            clearInterval(interval);
    }, [ward]);
    const latestByDevice = {};
    observations.forEach(
        observation => {
            if (
                !latestByDevice[
                    observation.device
                    ]
            ) {
                latestByDevice[
                    observation.device
                    ] = observation;
            }
        }
    );
    const liveData =
        Object.values(
            latestByDevice
        );
    return (
        <section className="container-fluid mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>
                        Live IoT Monitoring
                    </h3>

                    <p>
                        Real-time hospital device observations
                    </p>

                </div>


                <div>

                    <select
                        className="form-control"
                        value={ward}
                        onChange={(e) =>
                            setWard(
                                e.target.value
                            )
                        }
                    >

                        <option value="ICU">
                            ICU
                        </option>

                        <option value="HDU">
                            HDU
                        </option>

                        <option value="Emergency">
                            Emergency
                        </option>

                        <option value="Ward">
                            Ward
                        </option>

                        <option value="OT">
                            OT
                        </option>

                    </select>

                </div>

            </div>


            {loading && (
                <div className="text-muted mb-3">
                    Updating...
                </div>
            )}


            <div className="row g-3">

                {liveData.length === 0 ? (
                    <div className="col-12">

                        <div className="card shadow-sm">

                            <div className="card-body text-center">

                                <h5>
                                    No live observations
                                </h5>

                                <p className="text-muted">
                                    No IoT data is currently available for this ward.
                                </p>

                            </div>

                        </div>

                    </div>
                ) : (
                    liveData.map(
                        observation => (
                            <div
                                className="col-xl-3 col-lg-4 col-md-6"
                                key={
                                    observation.id
                                }
                            >

                                <div className="card shadow-sm iot-monitor-card">

                                    <div className="card-header">

                                        <strong>
                                            Device #
                                            {
                                                observation.device
                                            }
                                        </strong>

                                    </div>


                                    <div className="card-body">

                                        <div className="row g-2">

                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        Heart Rate
                                                    </small>

                                                    <strong>
                                                        {
                                                            observation.heart_rate ??
                                                            "--"
                                                        }
                                                        <span>
                                                            {" "}bpm
                                                        </span>
                                                    </strong>

                                                </div>

                                            </div>


                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        SpO2
                                                    </small>

                                                    <strong>
                                                        {
                                                            observation.spo2 ??
                                                            "--"
                                                        }
                                                        <span>
                                                            {" "}%
                                                        </span>
                                                    </strong>

                                                </div>

                                            </div>


                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        BP
                                                    </small>

                                                    <strong>

                                                        {
                                                            observation.systolic_bp ??
                                                            "--"
                                                        }

                                                        /
                                                        {
                                                            observation.diastolic_bp ??
                                                            "--"
                                                        }

                                                    </strong>

                                                </div>

                                            </div>


                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        Temperature
                                                    </small>

                                                    <strong>

                                                        {
                                                            observation.temperature ??
                                                            "--"
                                                        }

                                                        °C

                                                    </strong>

                                                </div>

                                            </div>


                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        Resp. Rate
                                                    </small>

                                                    <strong>

                                                        {
                                                            observation.respiratory_rate ??
                                                            "--"
                                                        }

                                                    </strong>

                                                </div>

                                            </div>


                                            <div className="col-6">

                                                <div className="iot-vital-box">

                                                    <small>
                                                        Glucose
                                                    </small>

                                                    <strong>

                                                        {
                                                            observation.glucose ??
                                                            "--"
                                                        }

                                                    </strong>

                                                </div>

                                            </div>

                                        </div>


                                        <div className="text-muted small mt-3">

                                            Recorded:
                                            {" "}
                                            {
                                                observation.recorded_at
                                            }

                                        </div>

                                    </div>

                                </div>

                            </div>
                        )
                    )
                )}

            </div>

        </section>
    );
}
export default IoTLiveMonitoring;
